module.exports = __webpack_public_path__ + "media/images/burger-alternate-99083e1019b10b018338ac684264278f.svg";